module.exports = __webpack_public_path__ + "img/avatar5.1584cf42.png";